import { formatCents } from 'shared/money';
import { PriceChangePromptState } from '../../paySequence';

export interface PriceChangedTextValues {
  newPrice: string;
  oldPrice: string;
}

export function getPriceChangedTextValues({
  postedPriceCents,
  serverPriceCents,
}: PriceChangePromptState): PriceChangedTextValues {
  return {
    newPrice: formatCents(serverPriceCents),
    oldPrice: formatCents(postedPriceCents),
  };
}
